export const EmailIcon = () => {
    return (
        <svg width="22" height="17" viewBox="0 0 22 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.8386 10.8992C12.2913 11.2641 11.6555 11.457 11 11.457C10.3446 11.457 9.70879 11.2641 9.16145 10.8992L0.14648 4.88906C0.0964648 4.85571 0.0477383 4.82095 0 4.7852V14.6335C0 15.7626 0.916309 16.6588 2.02525 16.6588H19.9747C21.1038 16.6588 22 15.7424 22 14.6335V4.78516C21.9521 4.82099 21.9033 4.85584 21.8532 4.88923L12.8386 10.8992Z" fill="#43484A" />
            <path d="M0.861523 3.81645L9.8765 9.82666C10.2178 10.0542 10.6089 10.1679 11 10.1679C11.3911 10.1679 11.7822 10.0541 12.1235 9.82666L21.1385 3.81645C21.6779 3.45702 22 2.85546 22 2.2062C22 1.08983 21.0918 0.181641 19.9754 0.181641H2.02456C0.908231 0.181684 0 1.08987 0 2.20727C0 2.85546 0.322094 3.45702 0.861523 3.81645Z" fill="#43484A" />
        </svg>


    );
};
